import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { Polyline, PolylineProps } from 'react-leaflet';
import { ISegmentationPolygonProps } from '../SegmentationLayerFeatures';

interface IProps {
  isActive: boolean;
}

export const PolylineFeature = observer((props: ISegmentationPolygonProps & PolylineProps & IProps): ReactElement => {
  const handleRef = (element: Polyline<ISegmentationPolygonProps & PolylineProps>): void => {
    if (props.isActive && element && 'enableEdit' in element.leafletElement && typeof element.leafletElement.enableEdit === 'function') {
      element.leafletElement.enableEdit();
    }
  };

  return (
    <Polyline<ISegmentationPolygonProps & PolylineProps>
      {...props}
      ref={handleRef}
    />
  );
});
